/**
 * 子どもの月齢変換ユーティリティ
 *
 * ChildAgeRangeSlider などの共有コンポーネントと、
 * AnytimeConsultationSearch / AnytimeConsultationSearchTab から利用される。
 *
 * スライダー値 (0–35) と月齢・表示ラベルの相互変換を担う。
 *
 * 変換ルール:
 *   0–23  : そのまま月齢（0ヶ月〜23ヶ月）
 *   24–34 : 2歳〜12歳（1目盛で1年ずつ増加）
 *   35    : 18歳（上限固定）
 */

/**
 * スライダー値を月齢に変換する。
 * @param {number} value - スライダー位置 (0–35)
 * @param {boolean} isUpperLimit - 上限として扱う場合は true（年齢の末月を含める）
 * @returns {number} 月齢
 */
export function childAgeMonthConvert(value, isUpperLimit = false) {
  if (value <= 23) {
    return value;
  } else if (value < 35) {
    // 2歳から12歳まで 1目盛 = 1年。上限の場合は当該年齢の11ヶ月目まで含める。
    return (value - 24 + 2) * 12 + (isUpperLimit ? 11 : 0);
  } else {
    // 35 は 18歳固定
    return 18 * 12 + (isUpperLimit ? 11 : 0);
  }
}

/**
 * スライダー値を日本語表示ラベルに変換する。
 * @param {number} value - スライダー位置 (0–35)
 * @param {boolean} isUpperLimit - 上限として扱う場合は true
 * @returns {string} "Xヶ月" / "1歳Xヶ月" / "X歳"
 */
export function childAgeMonthLabel(value, isUpperLimit = false) {
  const months = childAgeMonthConvert(value, isUpperLimit);
  if (months < 12) return months + "ヶ月";
  if (months < 24) return "1歳" + (months % 12) + "ヶ月";
  return Math.floor(months / 12) + "歳";
}

/**
 * スライダー値のペア [min, max] を API 送信用の月齢範囲オブジェクトに変換する。
 * 全範囲 ([0, 35]) の場合はフィルタ不要とみなし空オブジェクト {} を返す。
 * @param {number[]} sliderValue - [min, max]（各値 0–35）
 * @returns {{ gte?: number, lte?: number }} 月齢範囲またはフィルタなし({})
 */
export function sliderToMonthRange(sliderValue) {
  const [min, max] = sliderValue;
  if (min === 0 && max === 35) return {};
  return {
    gte: childAgeMonthConvert(min, false),
    lte: childAgeMonthConvert(max, true),
  };
}
